import React from 'react';
import ReactDOM from 'react-dom';
import DayPicker from 'react-day-picker';
//import Cookies from 'universal-cookie';
import 'react-day-picker/lib/style.css';
import './index.css';

//const cookies = new Cookies();

// eslint-disable-next-line no-extend-native
Date.prototype.addHours = function(h) {
  this.setTime(this.getTime() + (h*60*60*1000));
  return this;
}

export default class TherapistDateFilter extends React.Component {
	constructor(props) {
		super(props);
		this.handleDayClick = this.handleDayClick.bind(this);
		this.clearselectedDays = this.clearselectedDays.bind(this);

		//default value
		var dates = [];

		//read cookies
		/*
		const cookiesSelectedDays = cookies.get('selectedDays');
		if ( cookiesSelectedDays && cookiesSelectedDays.length > 0 ){
			dates = cookiesSelectedDays.map( day => new Date(day) );
		}
		*/

		//read url query
		var urlParams = new URLSearchParams(window.location.search);
		if ( urlParams.has('dates') && urlParams.get('dates').length > 9 ){
			dates = urlParams.get('dates').split(',').filter( day => isValidDate(day) );
			dates = dates.map( day => new Date(day) );
		}

		this.state = {
			selectedDays: dates,
		};
	}

	clearselectedDays(){
		//cookies.set('selectedDays', [], { sameSite: 'lax' });
		this.setState({ selectedDays: [] });
	}

	handleDayClick(day, { selected, disabled }) {
		const days = this.state.selectedDays;

		if (disabled) {
			// Day is disabled, do nothing
			return;
		}

		if (selected) {
			//unselect
			const removeDay = day;
			//console.log(removeDay);
			const filtered = days.filter(item => {
				//console.log(item);
				return item.toISOString().slice(0,10) !== removeDay.toISOString().slice(0,10);
			});

			//console.log(filtered);
			//cookies.set('selectedDays', filtered, { sameSite: 'lax' });
			this.setState({ selectedDays: filtered });
			return;
		}

		
		days.push(day);
		//const uniqueDays = Array.from(new Set(days));
		//cookies.set('selectedDays', days, { sameSite: 'lax' });
		this.setState({ selectedDays: days });
	}

	render() {
		const selectedDays = this.state.selectedDays;

		//sort the dates
		selectedDays.sort( (a,b) => {
	  		return new Date(a) - new Date(b);
		});

		const daysString = selectedDays.map( day => day.toISOString().slice(0,10) );

		//console.log(daysString);
		return (
			<div className="daypicker-wrapper">
				<div className="selectedDays-wrapper">
					<label>Available Dates<small>Select one or more dates</small></label>
					{ (daysString && daysString.length > 0) ? (<button type="button" className="clearButton" onClick={this.clearselectedDays}><span>{daysString.length} selected</span><i className="fa fa-times" aria-hidden="true"></i></button>) : ('')}
					<input type="hidden" id="selectedDays" name="dates" value={daysString} />
				</div>
				<DayPicker disabledDays={ {before: new Date().addHours(24)} } onDayClick={this.handleDayClick} selectedDays={this.state.selectedDays} fromMonth={new Date().addHours(5)}/>
			</div>
		);
	}
}

ReactDOM.render(
	<TherapistDateFilter />,
	document.getElementById('TherapistDateFilter')
	);

function isValidDate(dateString) {
  var regEx = /^\d{4}-\d{2}-\d{2}$/;
  if(!dateString.match(regEx)) return false;  // Invalid format
  var d = new Date(dateString);
  var dNum = d.getTime();
  if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
  return d.toISOString().slice(0,10) === dateString;
}